import React, { useState } from 'react'
import { Alert, MenuItem, Stack, TextField, Typography } from '@mui/material'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

/**
 * OperationSaveModeDialog (C9, §8.7) — cómo se guarda la edición de una versión de biblioteca
 * (CA2.3). El selector de modo solo aparece cuando N4 permite las DOS salidas; con la versión en uso
 * Sun solo permite `NEW_VERSION` (RN-02.4) y no hay nada que elegir.
 *
 * S19 (RN-G22, Δ3): con `USE_WORKFLOW_INDEX` desactivado NO se pregunta por el index — ni selector
 * (K26) ni limitación por permisos `WORKFLOW_INDEX_*` — y la versión nace `APPROVED`.
 *
 * Patrón: `BomSaveModeDialog.jsx` de #117.
 */
const OperationSaveModeDialog = ({
  open = false,
  allowedSaveModes = [],
  indexOptions = [],
  defaultIndexValue = '',
  error = '',
  useIndex = true,
  onConfirm = () => {},
  onClose = () => {}
}) => {
  const { t_ } = useSmartTranslation()
  const [mode, setMode] = useState(allowedSaveModes[0] || '')
  const [indexValue, setIndexValue] = useState(defaultIndexValue)

  return (
    <SmartDialog
      setOpen={open}
      title={{ render: <Typography variant='h6'>{t_('Save changes')}</Typography> }}
      acceptLabel={t_(mode === 'OVERWRITE' ? 'Overwrite' : 'Create new version')}
      acceptCallback={() => onConfirm(mode || allowedSaveModes[0] || '', useIndex ? indexValue : 'APPROVED')}
      cancelCallback={onClose}
      autoClose={false}
      renderComponent={
        <Stack spacing={2} sx={{ mt: 1, minWidth: 280 }} data-testid='operation-save-mode-dialog'>
          {error ? <Alert severity='warning'>{t_(error)}</Alert> : null}
          {allowedSaveModes.length > 1
            ? (
              <TextField select label={t_('Save mode')} value={mode} onChange={(event) => setMode(event.target.value)}>
                {allowedSaveModes.map((option) => (
                  <MenuItem key={option} value={option}>
                    {t_(option === 'OVERWRITE' ? 'Overwrite' : 'Create new version')}
                  </MenuItem>
                ))}
              </TextField>
              )
            : null}
          {useIndex
            ? (
              <TextField select label={t_('Index')} value={indexValue} onChange={(event) => setIndexValue(event.target.value)}>
                {indexOptions.map((option) => (
                  <MenuItem key={option.id || option.name} value={option.name}>{option.name}</MenuItem>
                ))}
              </TextField>
              )
            : null}
        </Stack>
      }
    />
  )
}

export default OperationSaveModeDialog
